import React, { useEffect, useState } from 'react';
import ApexCharts from 'apexcharts';
import { Box } from '@mui/material';

/* eslint-disable react/prop-types */
export default function BarGroupApexChart({ name, data, series1 = null, series2 = null }) {
  const [idname] = useState(name);
  const [renderChart, setRenderChart] = useState(false);
  const options = {
    series: [
      {
        name: series1 !== null ? series1 : 'Presented',
        data: data?.value,
      },
      {
        name: series2 !== null ? series2 : 'Coverage',
        data: data?.value1,
      },
    ],
    chart: {
      type: 'bar',
      height: 450,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: 'top',
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetX: -6,
      style: {
        fontSize: '12px',
        colors: ['#fff'],
      },
    },
    stroke: {
      show: true,
      width: 1,
      colors: ['#fff'],
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
    xaxis: {
      categories: data?.label,
    },
  };

  useEffect(() => {
    if (renderChart) {
      const chart = new ApexCharts(document.querySelector(`#${idname}`), options);
      chart.render();
    }

    setRenderChart(true);
  }, [renderChart]);

  return (
    <Box>
      <div id={idname} />
    </Box>
  );
}
